import { render, staticRenderFns } from "./WeekRewardConfig.vue?vue&type=template&id=fda5b402&scoped=true"
import script from "./WeekRewardConfig.vue?vue&type=script&lang=js"
export * from "./WeekRewardConfig.vue?vue&type=script&lang=js"
import style0 from "./WeekRewardConfig.vue?vue&type=style&index=0&id=fda5b402&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda5b402",
  null
  
)

export default component.exports